import { Box } from "@jewlr/storybook/core"
import React from "react"
import { Link } from "react-router-dom"

import { Section, SectionList, Text } from "@jewlr/storybook/info"
import { jewlr_t } from "helpers/application"
import { showHolidayRma, holidayRmaDates } from "helpers/holiday"

const WarrantyOld = () => (
  <Box mb={7}>
    <Section>
      <Box contain>
        <Text>
          We offer a one year warranty on all our {jewlr_t("terms.jewelry")}{" "}
          against manufacturing defects and workmanship. The warranty becomes
          void if the product has been subjected to misuse or has been altered
          by anyone other than an authorized Jewlr representative.
        </Text>
        <Text>
          Our dedicated Quality Assurance Team inspects every item before
          shipment to ensure that you receive a high quality piece. In the rare
          event that your item has a defect, please use our{" "}
          <Link data-lc="warranty-old" to="/order/repair">
            Request Repair Form
          </Link>{" "}
          to request a repair, or contact a customer service representative at{" "}
          <a href={`tel:${sl.config.customer_service_toll_free}}`}>
            {sl.config.customer_service_toll_free}
          </a>{" "}
          and we&apos;d be happy to assist you in getting your item repaired.
          Please include your order number and contact information in your
          communications with us.
        </Text>
      </Box>
    </Section>
    <Section hasBg>
      <Box contain>
        <Text subtitle>Please Note:</Text>
        <SectionList>
          <li>
            The customer will be responsible for any {jewlr_t("terms.shipping")}{" "}
            charges related to a warranty repair.
          </li>
          <li>
            We reserve the right to void the warranty on any item that shows
            signs of modification, abuse or damage beyond normal wear, as deemed
            by our {jewlr_t("terms.jewelry")} professionals.
          </li>
          <li>We will not be responsible for lost or stolen items.</li>
        </SectionList>
      </Box>
    </Section>
    {showHolidayRma() && (
      <Section>
        <Box contain>
          <Text>
            In order to focus on customer orders and ensure all gifts arrive for
            the holidays, we will not be processing repairs or returns between{" "}
            {holidayRmaDates.start} and {holidayRmaDates.end}. Don&apos;t worry
            &ndash; you&apos;re still covered! We will adjust or extend your
            repair or return deadline accordingly. Thank you for your
            understanding and cooperation during this busy time.
          </Text>
        </Box>
      </Section>
    )}
    <Section>
      <Box contain>
        <Text>
          For any questions, please email us at{" "}
          <a href={`mailto:${sl.config.customer_service_email}`}>
            {sl.config.customer_service_email}
          </a>
        </Text>
      </Box>
    </Section>
  </Box>
)

export default WarrantyOld
